module.exports = __webpack_public_path__ + "img/payroll04.9f46ed6e.jpeg";